import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import Dropdown from "components/Dropdown";
import TextArea from "components/TextArea";
import ModalGeneralSuccessfully from "screens/ModalGeneralSuccessfully";
import ModalAddChargeFailed from "screens/ModalAddChargeFailed";
import { useMutation } from "@apollo/client";
import { VERIFY_EMAIL, VERIFY_PHONE_NUMBER } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import colors from "constants/colors";
import ModalGeneralFailed from "screens/ModalGeneralFailed";

const ModalConfirmationRequired = ({
  hidden,
  userId,
  email,
  phoneNumber
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const [verifyEmail, { loading: emailLoading }] = useMutation(VERIFY_EMAIL);

  const [verifyPhoneNumber, { loading: phoneNumberLoading }] = useMutation(VERIFY_PHONE_NUMBER);

  const handleVerifyEmail = () => {
    if (emailLoading) return;
    if(verificationCode.trim() === "" || verificationCode.length !== 6) {
      return;
    }

    verifyEmail({
      variables: {
        input: {
          userId,
          input: {
            verificationCode
          }
        }
      }
    })
  };

  const handleVerifyPhoneNumber = () => {
    if (phoneNumberLoading) return;
    if(verificationCode.trim() === "" || verificationCode.length !== 6) {
      return;
    }

    verifyPhoneNumber({
      variables: {
        input: {
          userId,
          input: {
            verificationCode
          }
        }
      }
    })
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Add Charge</Head>
        <Container>
          <Input
            title="CHARGE AMOUNT"
            required
            value={verificationCode}
            onChange={(e) => {
              setVerificationCode(e.target.value);
            }}
            additionalstyle={`
              width: calc(50% - 8px);

              input {
                padding-left: 22px;
              }

              ::before {
                content: '$';
                font-size: 16px;
                font-weight: 600;
                position: absolute;
                color: ${colors.white};
                left: 12px;
                top: 32px;
              }

              .warning {
                white-space: nowrap;
              }
            `}
          />
        </Container>
        <Footer>
          {email?.length ? (
          <Button
            success
            additionalstyle={`
              width: 183px;
            `}
            onClick={handleVerifyEmail}
            data-loading={emailLoading}
          >
            {emailLoading ? null : "Verify Email Address"}
          </Button>
          ) : (
            <Button
              success
              additionalstyle={`
                width: 187px;
              `}
              onClick={handleVerifyPhoneNumber}
              data-loading={phoneNumberLoading}
            >
              {phoneNumberLoading ? null : "Verify Phone Number"}
            </Button>
          )}
        </Footer>
      </MainModal>
      <ModalGeneralSuccessfully

      />
      <ModalGeneralFailed

      />
    </>
  );
};

export default ModalConfirmationRequired;
